import type { ReactNode } from 'react';

export const symbol_computer_cancel: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m480-498 101 101q8.8 9 20.9 9 12.1 0 21.1-8.84 9-8.84 9-21T623-439L522-540l101-101q9-8.8 9-20.9 0-12.1-8.84-21.1-8.84-9-21-9T581-683L480-582 379-683q-8.8-9-20.9-9-12.1 0-21.1 8.84-9 8.84-9 21t9 21.16l101 101-101 101q-9 8.8-9 20.9 0 12.1 8.84 21.1 8.84 9 21 9t21.16-9l101-101ZM70-120q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q57.25-180 70-180h820q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H70Zm70-120q-24 0-42-18t-18-42v-480q0-24 18-42t42-18h680q24 0 42 18t18 42v480q0 24-18 42t-42 18H140Zm0-60h680v-480H140v480Zm0 0v-480 480Z"
		/>
	</svg>
);
